export const featureList = [
    {
        key: "f1",
        feature: [
            {
                title: "Centralized Student Profiles",
                message:
                    "Maintain detailed student records including personal, academic, and guardian information in one centralized platform."
            },
            {
                title: "Real-Time Data Access",
                message:
                    "Instantly retrieve or update student data from any department or device with proper access permissions."
            },
            {
                title: "Academic Performance Tracking",
                message:
                    "Monitor each student’s academic progress with detailed grade reports, attendance records, and behavioral notes."
            },
            {
                title: "Automated Attendance Management",
                message:
                    "Easily manage attendance using smart digital logs and generate reports for students or classes in seconds."
            },
            {
                title: "Secure Document Storage",
                message:
                    "Upload and store essential student documents such as ID proofs, certificates, and transcripts with encrypted cloud storage."
            },
            {
                title: "Guardian & Parent Communication",
                message:
                    "Enable direct communication with parents or guardians for academic updates, attendance notifications, and fee reminders."
            },
            {
                title: "Customizable Reporting Tools",
                message:
                    "Generate reports for academic performance, attendance, or admissions with flexible filtering and export options."
            }
        ]
    },
    {
        key: "f2",
        feature: [
            {
                title: "Comprehensive Teacher Dashboard",
                message:
                    "Provide teachers with an intuitive dashboard displaying class schedules, upcoming lessons, assignments, and announcements in one place."
            },
            {
                title: "Digital Attendance Management",
                message:
                    "Allow teachers to take daily attendance digitally, track absentees, and sync data directly with the administration system."
            },
            {
                title: "Lesson Planning & Scheduling",
                message:
                    "Enable teachers to plan, organize, and schedule lessons with built-in templates and drag-and-drop calendar functionality."
            },
            {
                title: "Assignment Creation & Evaluation",
                message:
                    "Simplify assignment management — teachers can create, distribute, and evaluate assignments, and share feedback instantly."
            },
            {
                title: "Student Performance Insights",
                message:
                    "Access visual analytics of each student’s performance, attendance, and behavior to make data-driven academic decisions."
            },
            {
                title: "Communication & Collaboration Tools",
                message:
                    "Facilitate seamless communication with students, parents, and administrators through built-in chat and announcement systems."
            },
            {
                title: "Resource Sharing",
                message:
                    "Allow teachers to upload and share study materials, notes, and multimedia resources securely with students and colleagues."
            },
            {
                title: "Performance Appraisal & Feedback",
                message:
                    "Support teacher growth with built-in evaluation modules for performance reviews, peer feedback, and self-assessment."
            }
        ]
    },
    {
        key: "f3",
        feature: [
            {
                title: "Comprehensive Data Visualization",
                message:
                    "Gain deep insights with interactive charts, graphs, and dashboards that visualize academic, attendance, and financial data in real time."
            },
            {
                title: "Custom Report Generation",
                message:
                    "Easily generate custom reports for students, teachers, departments, or sessions using advanced filtering and sorting options."
            },
            {
                title: "Attendance & Academic Analytics",
                message:
                    "Monitor student attendance trends, subject performance, and academic progress through intuitive analytics modules."
            },
            {
                title: "Teacher & Department Performance Metrics",
                message:
                    "Evaluate teacher productivity, course completion rates, and departmental performance with detailed comparison analytics."
            },
            {
                title: "Financial Reports",
                message:
                    "Generate fee collection, pending payments, and expense reports to ensure transparent financial management."
            },
            {
                title: "Export & Share Reports",
                message:
                    "Easily export reports in multiple formats (PDF, CSV, Excel) and share them securely with stakeholders."
            },
            {
                title: "Predictive Insights",
                message:
                    "Leverage AI-driven analytics to forecast academic outcomes, attendance dips, or financial performance trends."
            },
            {
                title: "Role-Based Access",
                message:
                    "Ensure data privacy by controlling who can access or generate reports through role-based permissions and access control."
            }
        ]
    },
    {
        key: "f4",
        feature: [
            {
                title: "Centralized Exam Scheduling",
                message:
                    "Easily plan, organize, and publish examination timetables for different classes and subjects, minimizing scheduling conflicts."
            },
            {
                title: "Online Exam Creation",
                message:
                    "Allow teachers to create and conduct objective or descriptive exams online with flexible question formats and automated grading options."
            },
            {
                title: "Secure Result Processing",
                message:
                    "Automate marks entry, grade calculations, and result generation with built-in validation to eliminate manual errors."
            },
            {
                title: "Result Publishing Portal",
                message:
                    "Publish results online for students and parents to access securely via dashboards, mobile apps, or web portals."
            },
            {
                title: "Revaluation & Rechecking Management",
                message:
                    "Simplify revaluation requests, approval workflows, and result updates to ensure transparency and accountability."
            },
            {
                title: "Marksheet & Certificate Generation",
                message:
                    "Instantly generate digital or printable marksheets and certificates with official templates and auto-filled data."
            },
            {
                title: "Performance Insights & Comparison",
                message:
                    "Analyze class-wise, subject-wise, or student-wise performance trends to identify academic strengths and weaknesses."
            },
            {
                title: "Result Archiving & Data Backup",
                message:
                    "Maintain historical exam and result data with secure cloud storage for easy retrieval and long-term records."
            }
        ]
    },
    {
        key: "f5",
        feature: [
            {
                title: "Digital Admission Form",
                message:
                    "Provide an easy-to-use online admission form for new applicants to submit details, documents, and preferences seamlessly."
            },
            {
                title: "Automated Application Screening",
                message:
                    "Automatically validate and filter applications based on eligibility criteria, reducing manual workload for the admin staff."
            },
            {
                title: "Document Upload & Verification",
                message:
                    "Allow applicants to upload required documents online and enable the admin team to verify them digitally for faster processing."
            },
            {
                title: "Real-Time Application Tracking",
                message:
                    "Enable students and parents to track admission status, payment updates, and notifications in real time."
            },
            {
                title: "Fee Payment Integration",
                message:
                    "Integrate secure online payment gateways to handle admission and registration fees with automated receipt generation."
            },
            {
                title: "Admission Approval Workflow",
                message:
                    "Streamline approval processes with multi-level verification and digital signatures for hassle-free student onboarding."
            },
            {
                title: "Existing Student Re-Registration",
                message:
                    "Simplify returning students’ registration for new academic sessions with pre-filled data and one-click confirmation."
            },
            {
                title: "Data Synchronization with Student Records",
                message:
                    "Automatically sync admission data with the central student database to avoid duplication and ensure accurate records."
            }
        ]
    },
    {
        key: "f6",
        feature: [
            {
                title: "Automated Admit Card Generation",
                message:
                    "Generate admit cards automatically based on approved exam schedules and student eligibility criteria."
            },
            {
                title: "Customizable Admit Card Templates",
                message:
                    "Design and customize admit card templates with institute logos, signatures, QR codes, and exam details."
            },
            {
                title: "Online Availability & Download",
                message:
                    "Allow students to securely access and download their admit cards directly from their online dashboard."
            },
            {
                title: "QR Code & Barcode Integration",
                message:
                    "Include unique QR or barcodes on each admit card for quick identity verification during exams."
            },
            {
                title: "Admin Verification Panel",
                message:
                    "Provide administrators and invigilators with tools to validate admit cards in real time during examination entry."
            },
            {
                title: "Bulk Generation & Printing",
                message:
                    "Support bulk admit card generation and printing for large batches of students with a single click."
            },
            {
                title: "Email & SMS Notifications",
                message:
                    "Notify students automatically via email or SMS when admit cards are released or updated."
            },
            {
                title: "Secure Cloud Storage",
                message:
                    "Store all admit cards securely in the cloud for future reference, reducing paperwork and manual management."
            }
        ]
    },
    {
        key: "f7",
        feature: [
            {
                title: "Automated Certificate & Marksheet Generation",
                message:
                    "Generate academic certificates and marksheets automatically using predefined templates linked with student data and exam results."
            },
            {
                title: "Custom Template Builder",
                message:
                    "Design custom certificate and marksheet templates with institute branding, signatures, and watermarks for authenticity."
            },
            {
                title: "Digital Signature & Seal Integration",
                message:
                    "Attach authorized digital signatures and institutional seals to make documents legally valid and tamper-proof."
            },
            {
                title: "QR Code Verification System",
                message:
                    "Embed a unique QR code on each certificate or marksheet to allow online verification and prevent forgery."
            },
            {
                title: "Batch Generation & Printing",
                message:
                    "Generate and print certificates or marksheets for entire batches with just a few clicks, saving time and effort."
            },
            {
                title: "Online Access for Students",
                message:
                    "Enable students to securely download their digital certificates and marksheets from their dashboard anytime."
            },
            {
                title: "Cloud Storage & Archiving",
                message:
                    "Store all generated documents securely in the cloud for easy retrieval and historical record-keeping."
            },
            {
                title: "Role-Based Approval Workflow",
                message:
                    "Manage certificate and marksheet approval through a multi-level verification system involving teachers, exam controllers, and administrators."
            }
        ]
    },
    {
        key: "f8",
        feature: [
            {
                title: "Personalized Student Overview",
                message:
                    "Provide students with a centralized dashboard showing their attendance, grades, upcoming classes, and announcements at a glance."
            },
            {
                title: "Academic Progress Tracking",
                message:
                    "Display subject-wise marks, performance graphs, and semester-wise reports to help students monitor their academic growth."
            },
            {
                title: "Attendance Summary",
                message:
                    "Allow students to view real-time attendance records, monthly summaries, and alerts for low attendance."
            },
            {
                title: "Assignment & Exam Updates",
                message:
                    "Show upcoming assignments, submission deadlines, and scheduled exams in a well-organized interface."
            },
            {
                title: "Fee Payment & Receipts",
                message:
                    "Enable students to pay fees online, download receipts, and track payment history directly from their dashboard."
            },
            {
                title: "Notifications & Alerts",
                message:
                    "Keep students informed about important announcements, upcoming events, and results through in-app notifications."
            },
            {
                title: "Resource & Study Material Access",
                message:
                    "Provide direct access to shared notes, class materials, and recorded sessions uploaded by teachers."
            },
            {
                title: "Profile Management",
                message:
                    "Allow students to update personal details, contact information, and preferences with admin approval for secure record management."
            }
        ]
    },
    {
        key: "f9",
        feature: [
            {
                title: "Centralized Event Calendar",
                message:
                    "Manage all school and college events — from annual functions to workshops — in a unified calendar accessible to students and staff."
            },
            {
                title: "Event Creation & Approval Workflow",
                message:
                    "Allow authorized staff to create new events, set schedules, assign organizers, and route for administrative approval seamlessly."
            },
            {
                title: "Online Registration & Participation",
                message:
                    "Enable students and faculty to register for events online, track participation lists, and receive digital confirmation instantly."
            },
            {
                title: "Automated Notifications & Reminders",
                message:
                    "Send automated event reminders and updates through SMS, email, or in-app notifications to all registered participants."
            },
            {
                title: "Resource & Venue Management",
                message:
                    "Simplify the process of booking venues, allocating resources, and managing event logistics with real-time availability tracking."
            },
            {
                title: "Post-Event Feedback Collection",
                message:
                    "Gather participant feedback digitally after each event to evaluate engagement and improve future event planning."
            },
            {
                title: "Photo Gallery & Media Uploads",
                message:
                    "Allow event organizers to upload event photos, videos, and highlights to create a digital archive of institutional activities."
            },
            {
                title: "Reports & Participation Analytics",
                message:
                    "Generate event-wise reports, track attendance, and analyze participation trends to measure student involvement and engagement."
            }
        ]
    }
]
export const featureMapList = [
    {
        title: "Student Information Management",
        desc: "Maintain complete student records including profiles, attendance, performance, and documents — all in one place.",
        key: "f1"
    },
    {
        title: "Teacher Portal",
        desc: "Empower teachers with tools to manage classes, grades, schedules, and student communication effortlessly.",
        key: "f2"
    },
    {
        title: "Reports & Analytics Dashboard",
        desc: "Access smart reports and visual analytics to make data-driven academic and administrative decisions.",
        key: "f3"
    },
    {
        title: "Exam & Results Management",
        desc: "Easily conduct exams and publish class, sessional, and term results online in just a few clicks.",
        key: "f4"
    },
    {
        title: "Online Admission & Registration",
        desc: "Simplify student enrollment with a digital registration process and seamless admission workflow.",
        key: "f5"
    },
    {
        title: "Digital Admit Cards",
        desc: "Generate and distribute examination admit cards online to save time and minimize manual work.",
        key: "f6"
    },
    {
        title: "Certificates & Mark Sheets",
        desc: "Create and issue academic certificates or mark sheets securely with verified digital records.",
        key: "f7"
    },
    {
        title: "Student Dashboard",
        desc: "Provide students with a personalized dashboard to view classes, grades, assignments, and announcements.",
        key: "f8"
    },
    {
        title: "Event & Activity Management",
        desc: "Plan and manage school or college events, track participation, and share updates with students and staff.",
        key: "f9"
    }
]
export const servicesList = [
    {
        title: "Custom Web Development",
        desc: "We build fast, responsive, and scalable websites tailored to your business goals using the latest technologies like React, Next.js, and Node.js."
    },
    {
        title: "Mobile App Development",
        desc: "Design and develop high-performance mobile applications for Android and iOS with seamless user experiences using React Native and Flutter."
    },
    {
        title: "Enterprise Software Solutions",
        desc: "From ERP systems to custom CRM and management platforms, we deliver secure, reliable software that streamlines business operations."
    },
    {
        title: "UI/UX Design",
        desc: "Our creative team crafts intuitive and visually engaging user interfaces to ensure your customers enjoy a smooth, modern experience."
    },
    {
        title: "E-Commerce Solutions",
        desc: "Launch and manage powerful online stores with features like product management, secure payments, and analytics dashboards."
    },
    {
        title: "Cloud Integration & Deployment",
        desc: "We help businesses migrate and deploy applications securely on cloud platforms like AWS, Azure, and Firebase for improved scalability."
    },
    {
        title: "Maintenance & Support",
        desc: "Our dedicated team provides continuous monitoring, updates, and technical support to ensure your applications run flawlessly."
    },
    {
        title: "API Development & Integration",
        desc: "Build secure and scalable RESTful APIs or integrate third-party services to connect systems and enhance functionality."
    },
    {
        title: "Consulting & Digital Transformation",
        desc: "Empower your business with strategic technology consulting, helping you adapt modern tools and achieve digital growth."
    }
]
